import reduce from 'just-reduce-object';

export const nonFalseValues = ({ variables, defaultValues }): Record<string, any> => {
  const newValues = reduce(
    variables,
    (acc, key, value) => {
      // console.log(key, value);
      // console.log({ defaultValues });
      // // if key is in defaultValues object then delete it from acc
      // if (Object.prototype.hasOwnProperty.call(defaultValues, key) && defaultValues[key] === value) {
      //   console.log('delete', key, defaultValues[key], value);
      //   delete acc[key];
      //   return acc;
      // }

      if (
        (!Array.isArray(value) && value !== 'NaN' && value !== '' && typeof value !== 'undefined') ||
        (Array.isArray(value) && value.length > 0)
      ) {
        acc[key] = value;
      } else {
        // console.log(`delete ${key}`);
        delete acc[key];
      }
      return acc;
    },
    {}
  );

  return newValues;
};
